module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/3_83065384a4c0798fc9bb8f51e80ad7f6.png";